import React from 'react'

import { EChart } from '@/components/charts/EChart'
import { buildBarOption } from '@/components/charts/nivoToEcharts.helpers'

// Renders on ECharts but keeps the nivo bar prop shapes its consumers pass
// (data/keys/indexBy, axisBottom/axisLeft, tooltip render functions).
const BarChart = (props) => (
  <EChart option={buildBarOption(props)} style={{ width: '100%', height: '100%' }} />
)

export default BarChart
